import { GetVenue_venue } from "@ticketingplatform/api/src/venue/__generated__/GetVenue";
import { useMemo } from "react";

import { VenueFormValues } from "../VenueForm/types";

export const useVenueShape = (
  data: GetVenue_venue | null | undefined
): VenueFormValues | undefined =>
  useMemo(() => {
    if (!data) {
      return undefined;
    }

    const { address, organization, image } = data;
    const { country, countryCode } = address || {};

    return {
      input: {
        ...data,
        organizationId: organization,
        image: image || undefined,
        address: {
          ...address,
          country:
            country && countryCode
              ? {
                  value: countryCode,
                  label: country,
                }
              : undefined,
        },
      },
    };
  }, [data]);
